import * as React from 'react'
import TitledPage from "../layout/TitledPage";
import {Heading, Box} from "@chakra-ui/react";
import Playlist from "touhou-fm/Playlist";

export default () => <TitledPage title="Music">
    <Box borderWidth="1px" borderStyle="solid" borderColor="primary.100" rounded="md">
        <Heading as="h2" size="lg" textAlign="center">Playlist</Heading>
        <Playlist/>
    </Box>
</TitledPage>